module.exports = "/shape-arrow-right.svg?9a6ed4";